/**
 * The two DOM helpers this bundle needs, and no framework.
 *
 * LunaPin's web layer draws four surfaces — the inside of a window, the account corner,
 * the signed-out landing page and the sign-in dialog — and every one of them is a handful
 * of elements built once and repainted wholesale. That is small enough that a rendering
 * library would be the largest thing in the bundle, and it is why these two functions are
 * the whole of the abstraction.
 *
 * `textContent` throughout, never `innerHTML`: everything here paints strings that came
 * from the server — including its refusal messages, which are the one class of string an
 * attacker has any influence over — and the day one of those carries a `<script>` is not a
 * day worth preparing for by escaping. It is a day to have never been assigning markup in
 * the first place.
 */
package se.soderbjorn.lunapin.web

import kotlinx.browser.document
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLElement

/** A `<tag class="…">` with optional text. */
internal fun element(tag: String, className: String, text: String? = null): HTMLElement {
    val el = document.createElement(tag) as HTMLElement
    el.className = className
    if (text != null) el.textContent = text
    return el
}

/**
 * A `<button type="button">`.
 *
 * `type` is set explicitly, and it earns its line: the sign-in dialog **is** a `<form>`,
 * where a bare `<button>` defaults to `submit`. Cancel and the password reveal are both
 * built through here and sit inside that form, so without this they would submit the
 * credential — Cancel would sign you in, and revealing your password would too.
 */
internal fun button(label: String, className: String, onClick: () -> Unit): HTMLButtonElement {
    val el = document.createElement("button") as HTMLButtonElement
    el.type = "button"
    el.className = className
    el.textContent = label
    el.addEventListener("click", { onClick() })
    return el
}
